import Button from "components/common/Button";
import TextFieldCustom from "components/TextFieldCustom";
import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const initValue = '';

const MissionAbortModal = ({ isShow, initModal, reloadData }) => {

    const [reason, setReason] = useState(initValue);

    const navigate = useNavigate();
    const handleAbortMission = () => {
        reloadData(reason);
        setReason(initValue);
        navigate('/portal/mission-cc')
    }

    const handleClose = () => {
        initModal();
        setReason(initValue);
    }

    return (
        <React.Fragment>
            <Modal show={isShow} size="lg">
                <Modal.Header closeButton onClick={() => initModal()}>
                    <Modal.Title><h1>Abort Mission</h1></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <TextFieldCustom
                        label={"Reason"}
                        fullWidth
                        multiline={true}
                        minRows={4}
                        value={reason}
                        onChange={(e) => setReason(e.target.value)}
                        size="small"
                        sx={{
                            marginTop: "6px",
                            marginBottom: "6px",
                            backgroundColor: "white",
                        }}
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        onClick={handleAbortMission}
                    >
                        Abort
                    </Button>
                    <Button
                        variant="secondary"
                        onClick={handleClose}
                    >
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </React.Fragment>
    );
}

MissionAbortModal.defaultProps = {
    isShow: false,
    initModal: () => {},
    reloadData: () => {},
};

export default MissionAbortModal;